import React, { useState } from "react";
import { ReactComponent as AddTeamVector } from "../../StaticData/Vectors/addTeamVector.svg";
import { Grid, Box } from "@mui/material";
import { Formik, Form } from "formik";
// import { addTeamValues } from "../../../OKRManagment/StaticData";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import { addTeamsinintialValues } from "../../StaticData";
import { useAddTeam } from "../../Hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { addTeamSchema } from "../../StaticData";
import { useGetAllActivePersonByTenantId } from "../../Hooks";
// import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";

import { ErrorMessage } from "formik";
// import { useSelector } from 'react-redux';
// import { Button } from "@mui/material";
import "../RegisterTenant/Error.css";
import CustomeMultiSelect from "../../../OKRManagment/new/customeMultiSelect";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";

const AddTeam = (props: any) => {
  let { setShowToastMessage, setAddTeamState, onClose, id } = props;
  const tenantId: any = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const { data: activePersonData, isLoading: getActivePersonLoading } =
    useGetAllActivePersonByTenantId(tenantId);
  const [personIdData, setPersonIdData] = useState([]);
  const { data: addTeamData, mutate: addTeam, isSuccess } = useAddTeam();
  // const [addTeamMesaage, setAddTeamMessage] = useState<string>("");
  // const [successAddTeam, setSuccessAddTeam] = useState<Boolean>(false)
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);
  const [allTeamAndPersonBaseData, setAllTeamAndPersonBaseData] = useState<any>(
    []
  );

  // useEffect(() => {
  //   // if (addTeamData) {
  //   //   setShowToastMessage(true);
  //   //   setAddTeamState(addTeamData?.data);
  //   //   onClose(false);
  //   // }
  //   if (addTeamData) {
  //     if (addTeamData?.data.isSuccess) {
  //       setShowToastMessage(true);
  //       setAddTeamState(addTeamData?.data);
  //       onClose(false);
  //     } else {
  //       setShowLtoastMessage(true);
  //       onClose(true);
  //       SetIsSuccess(false);
  //       SetTMessage(addTeamData?.data.measData.message)
  //       // setAddKrStatusData(data?.data);
  //       // setIsSubmitting(false); // بازنشانی وضعیت در صورت خطا
  //     }
  //   }
  // }, [addTeamData, isSuccess]);

  useEffect(() => {
    let localArray: any[] = [];
    setPersonIdData(
      activePersonData?.map((item: any) => {
        let { key, value } = item;
        localArray.push({
          id: item.value,
          name: item.key,
          checked: false,
        });
        return { year: value, title: key };
      })
    );
    setAllTeamAndPersonBaseData(localArray);
  }, [activePersonData]);

  useEffect(() => {
    // setAddTeamMessage(addTeamData?.data?.metaData.message)
    // setSuccessAddTeam(isSuccess)
    if (addTeamData) {
      setShowToastMessage(true);
      setAddTeamState(addTeamData?.data);
      onClose(false);
    }
  }, [addTeamData, isSuccess]);

  const initialSubmitForm = (data: any) => {
    // addTeam({...data,tenantId:tenantId})
    let selectedMembers: string[] = [];
    allTeamAndPersonBaseData.map(
      (item: any) => item.checked && selectedMembers.push(item.id)
    );

    addTeam({
      ...data,
      tenantId: tenantId,
      parentId: id,
      personIds: [...selectedMembers],
    });

    // console.log(data)
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box width={"100%"} textAlign={"center"}>
          <AddTeamVector style={{ width: "350px", height: "150px" }} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Formik
          enableReinitialize
          initialValues={addTeamsinintialValues}
          validationSchema={addTeamSchema}
          onSubmit={(data: any) => {
            initialSubmitForm(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
          }) => (
            <Form>
              <Grid
                container
                columnSpacing={1}
                sx={{
                  bgcolor: "background.paper",
                  mx: "auto",
                  borderRadius: 3,
                }}
              >
                <Grid item xs={12}></Grid>
                <Grid item xs={12} md={12}>
                  <div className="error">
                    <ErrorMessage name="name" />
                  </div>
                  <FormikControl
                    control="textField"
                    type="text"
                    label="نام"
                    name="name"
                    fullWidth
                    value={values.name || ""}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="error">
                    <ErrorMessage name="managerId" />
                  </div>
                  <FormikControl
                    control="select"
                    options={activePersonData || []}
                    label="مدیر"
                    name="managerId"
                    fullWidth
                    values={values?.managerId || ""}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                   <div className='error'>
                    <ErrorMessage name="personIds" />
                   </div>
              {/* <MultiSelect
                options={personIdData || []}
                isLoading={getActivePersonLoading}
                onChangee={setFieldValue}
                propName='personIds'
                label={'انتخاب اعضا'}
              />  */}
                  <div className=" relative cursor-pointer px-2">
                    <div
                      onClick={(e: React.MouseEvent<HTMLElement>) => {
                        e.preventDefault();
                        setShowMultiSelect(!showMultiSelect);
                      }}
                      className={` px-2 w-full py-2 mt-1 flex justify-between text-xs font-thin text-black 
                            
                              rounded-md  ml-3 border-2 ${
                                showMultiSelect
                                  ? "border-sky-600"
                                  : "border-slate-200"
                              }   `}
                    >
                      انتخاب اعضا
                      {showMultiSelect ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      )}
                    </div>

                    {showMultiSelect && allTeamAndPersonBaseData && (
                      <div className="absolute w-[98%] top-full right-0">
                        <CustomeMultiSelect
                          data={allTeamAndPersonBaseData}
                          setShowMultiSelect={setShowMultiSelect}
                          title="انتخاب اعضا"
                          setCheckBoxes={(id: string) => {
                            let tmpData: any = allTeamAndPersonBaseData.map(
                              (item: any) =>
                                item.id === id
                                  ? {
                                      ...item,
                                      checked: !item.checked,
                                    }
                                  : { ...item }
                            );
                            setAllTeamAndPersonBaseData(tmpData);
                          }}
                        ></CustomeMultiSelect>
                      </div>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} mt={1}>
                  <Box
                    px={1}
                    columnGap={2}
                    display={"flex"}
                    justifyContent={"center"}
                    flexDirection={"row-reverse"}
                  >
                    <Box>
                      <DyButton
                        caption={"ذخیره"}
                        color={"#00387C"}
                        onClick={() => {}}
                        disbled={!dirty || !isValid}
                        variant={"contained"}
                        bgColor={"#00387C"}
                        type={"submit"}
                      />
                    </Box>

                    <Box>
                      <DyButton
                        caption={"انصراف"}
                        disbled={false}
                        variant={"outlined"}
                        onClick={() => {
                          onClose(false);
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
      {showLtoastMessage && (
                <DYToastMessage
                  isSuccess={isSucces}
                  message={tMessage}
                  setShow={setShowLtoastMessage}
                  show={showLtoastMessage}
                />
              )}
    </Grid>
  );
};

export default AddTeam;
